module.exports = __webpack_public_path__ + "assets/9a04ad7498a5f5599f25eb595c9631b2.mp3";